export var TABLE_BODY_CLASS_PREFIX = 'TableBody';
export var tableBodyRootTestId = 'TableBodyRoot';